import React, { FC, useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ApplicationStore } from "src/store";

import { setCheckout, setCurrentWorkFlow } from "../../actions";
import {
  addToCheckout,
  addToCheckoutWithoutUuid,
  getCheckout,
} from "../../api";
import { SectionTree } from "../../types";
import {
  initMainGarderobo,
  sendTagManagerAddToCheckoutData,
  sendTagManagerGarderoboAddToCheckoutData,
  setBasketId,
} from "../../utils";

//import {getBasketId} from "../../utils";

export const OutfitPage: FC = () => {
  const smartRef = useRef(null as HTMLElement | null);

  const { userData } = useSelector((state: ApplicationStore) => state.user);

  const dispatch = useDispatch();

  const findProductByIdInData = (itemId: string, items: any) => {
    if (items) {
      return items.find(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (item: any) => {
          return item.product_id === parseInt(itemId);
        }
      );
    }
    return null;
  };

  const handleAddToCheckout = useCallback(
    (
      toggleCheckout,
      filteredProductId,
      checkoutId,
      filteredQuantity,
      filteredOfferId
    ) => {
      if (
        !!filteredProductId &&
        !!checkoutId &&
        !!filteredQuantity &&
        !!filteredOfferId
      ) {
        if (checkoutId === "undefined" || checkoutId === null) {
          addToCheckoutWithoutUuid({
            product_id: filteredProductId,
            quantity: filteredQuantity,
            offer_id: filteredOfferId,
          }).then(({ data }) => {
            setBasketId(data.basket_uuid);
            dispatch(
              setCurrentWorkFlow({
                userWorkFlow: "hasUuid",
              })
            );
            getCheckout(data.basket_uuid, true).then(({ data }) => {
              dispatch(setCheckout(data));
              const { items } = data.basket;
              sendTagManagerGarderoboAddToCheckoutData({
                offerid: JSON.stringify(items.map((item) => item.offer_id)),
              });
              if (window.matchMedia("(min-width: 768px)").matches) {
                toggleCheckout(true);
              }
              const product = findProductByIdInData(
                filteredProductId,
                data.basket.items
              );
              sendTagManagerAddToCheckoutData({
                productId: product.product_id,
                vendorCode: product.size_id_1c,
                offer: filteredOfferId,
                productName: product.offer.name,
                productPrice: product.offer.new_price,
                productBrand: product.product.brand.name,
                category: product.section_tree
                  .map((category: SectionTree) => category.name)
                  .join("/"),
                is_retail: userData?.is_retail ?? false,
              });
            });
          });
        } else {
          addToCheckout(checkoutId, {
            product_id: filteredProductId,
            basket_uuid: checkoutId,
            quantity: filteredQuantity,
            offer_id: filteredOfferId,
          }).then(() => {
            getCheckout(checkoutId, true).then(({ data }) => {
              dispatch(setCheckout(data));
              const { items } = data.basket;
              sendTagManagerGarderoboAddToCheckoutData({
                offerid: JSON.stringify(items.map((item) => item.offer_id)),
              });
              if (window.matchMedia("(min-width: 768px)").matches) {
                toggleCheckout(true);
              }
              const product = findProductByIdInData(
                filteredProductId,
                data.basket.items
              );
              sendTagManagerAddToCheckoutData({
                productId: product.product_id,
                vendorCode: product.size_id_1c,
                offer: filteredOfferId,
                productName: product.offer.name,
                productPrice: product.offer.new_price,
                productBrand: product.product.brand.name,
                category: product.section_tree
                  .map((category: SectionTree) => category.name)
                  .join("/"),
                is_retail: userData?.is_retail ?? false,
              });
            });
          });
        }
      }
    },
    []
  );

  useEffect(() => {
    initMainGarderobo();
  }, []);

  return (
    <>
      <div
        id="modatech-widgets"
        ref={smartRef as React.RefObject<HTMLDivElement>}
      ></div>
    </>
  );
};
